import { render, staticRenderFns } from "./MenuItemOptionWrapper.vue?vue&type=template&id=2332c210&scoped=true&"
import script from "./MenuItemOptionWrapper.vue?vue&type=script&lang=js&"
export * from "./MenuItemOptionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemOptionWrapper.vue?vue&type=style&index=0&id=2332c210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2332c210",
  null
  
)

export default component.exports